import { useEffect } from 'react';

export const useClickOutside = (
  ref: React.RefObject<HTMLDivElement>,
  onClick?: () => void,
  closeOnScrollAndResize?: boolean,
) => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const checkIfClickedOutside = (e: any) => {
      if (e.type === 'scroll' || e.type === 'resize') {
        if (closeOnScrollAndResize) {
          onClick?.();
        }

        return;
      }

      const target = e.target as EventTarget | null;
      if (!(target instanceof Node)) {
        return;
      }

      if (ref.current && !ref.current.contains(target)) {
        onClick?.();
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    document.addEventListener('touchstart', checkIfClickedOutside);
    window.addEventListener('scroll', checkIfClickedOutside);
    window.addEventListener('resize', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
      document.removeEventListener('touchstart', checkIfClickedOutside);
      window.removeEventListener('scroll', checkIfClickedOutside);
      window.removeEventListener('resize', checkIfClickedOutside);
    };
  }, [closeOnScrollAndResize, onClick, ref]);
};
